module.exports = __webpack_public_path__ + "img/notepad.f413103c.svg";